import React from 'react';
import { Sticker } from '../skills';
import { Icon } from '@iconify/react';
import "./stylesheet/portfolio.css"
// import Button from '../button';
 const data=[
  {icon:<Icon icon="logos:figma" />,
  level:"s"}  ,

{icon:<Icon icon="logos:sketch" />,
level:"b"},

{icon:<Icon icon="file-icons:adobe-xd" color="#9747ff" />,
level:"b"}
 ]
 const webicon=[{
   icon: <Icon icon="vscode-icons:file-type-html" />,
   level:"g"
 },{
    icon:  <Icon icon="vscode-icons:file-type-css" />,
   level:"g"
 },{
    icon: <Icon icon="logos:javascript" />,
   level:"g"
 },{
    icon: <Icon icon="vscode-icons:file-type-reactjs" />,
   level:"g"
 }
    
  
   
 ]
const Heading=(props)=>{
    return(
<div className={props.side==="left"?"pheadingcomponent-left":"pheadingcomponent-right"}>
    <h1>{props.heading}</h1>
    <div className="line">
    <div className="lineline"></div>
    </div>
    <div className="tools">
        <Sticker data={props.sticker}/>
    </div>
</div>
    )
}

// const CardComp=()=>{
//     return(
//         <div className="cardcontainer">
//         <div className="card"style={{background:"url(./media/csshr.png) no-repeat",backgroundSize:"contain",filter:"drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))" ,width:"90v",height:"auto"}}>
//           {/* <img src="./media/cssHr.png" alt="hello" /> */}
//         </div>
//         <Button title={"download"} link={"hello world"}/>
  
// </div>
//     )
   
  
// }

const PortfolioComponent = () => {
  return (
<>
<section className="container">
<Heading side={"left"} heading={"Design"} sticker={data}/>
<div className="project-card-u">
<img src="./media/comingsoon.svg" alt="" />
</div>

<Heading side={"right"} heading={"Web Projects"} sticker={webicon}/>
<div className="project-card">

</div>
</section>
</>
    )
}

export default PortfolioComponent